import React, { Component } from "react";
import { Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import Tooltip from "@mui/material/Tooltip";
import FloatingButton from "../../../Material/FloatingButton";
import { connect } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import * as FileSaver from "file-saver";
import XLSX from "xlsx";
import ReactTooltip from "react-tooltip";
import * as moment from "moment";
import Moment from "react-moment";

class approvedList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      MyTaskList: [],
      loading: "",
      downloadExcel: [],
      downloadExcelArray: [],
      isdownloadExcelFirstLoadDone: 0,
      donuts_category: localStorage.getItem("donuts_category")
        ? localStorage.getItem("donuts_category")
        : "",
      donuts_ggpstatus: localStorage.getItem("donuts_ggpstatus")
        ? localStorage.getItem("donuts_ggpstatus")
        : "",
      donuts_approvalstatus: localStorage.getItem("donuts_approvalstatus")
        ? localStorage.getItem("donuts_approvalstatus")
        : "",
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: "headerTitle",
      value: "My Task : Approved List",
    });
    this.GetListData("Approved");
  }

  componentDidUpdate() {
    localStorage.removeItem("donuts_ggpstatus");
    localStorage.removeItem("donuts_category");
    localStorage.removeItem("donuts_approvalstatus");
  }

  GetListData = (val) => {
    try {
      let postData = {
        UserId: parseInt(this.props.UserId),
        Status: val,
      };
      fetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/MyTask/MyTaskList", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ MyTaskList: data.resultObject, loading: "Yes" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  viewRequest = (value, tableMeta, updateValue) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/mytask/approved/view?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(tableMeta.rowData?.[0]),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  workflowRequest = (value, tableMeta, updateValue) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/mytask/approved/workflow?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(tableMeta.rowData?.[0]),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  downloadExcelFile = () => {
    const Heading = [
      {
        header1: "Reference No",
        header2: "Employee Name",
        header3: "eDoc Type",
        header4: "Submitted Date",
        header5: "Status",
        header6: "Description",
      },
    ];
    (async () => {
      await this.setState({ downloadExcelArray: [] });
    })();
    if (this.state.downloadExcel?.length > 0) {
      (async () => {
        await this.state.downloadExcel.forEach((value, index) => {
          let mdData = [
            value.data[0],
            value.data[1],
            value.data[2],
            value.data[3],
            value.data[4],
            value.data[5],
          ];
          this.state.downloadExcelArray.push(mdData);
          return null;
        });
      })();
    } else {
      (async () => {
        await this.state.MyTaskList.forEach((value, index) => {
          let mdData = [
            value.referenceno,
            value.employee,
            value.edoctype,
            value.submitteddate,
            value.status,
            value.description,
          ];
          this.state.downloadExcelArray.push(mdData);
          return null;
        });
      })();
    }
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const filename = "approved.xlsx";

    const ws = XLSX.utils.json_to_sheet(Heading, {
      skipHeader: true,
      origin: 0,
    });
    XLSX.utils.sheet_add_json(ws, this.state.downloadExcelArray, {
      skipHeader: true,
      origin: -1,
    });
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, filename);
  };

  printRequest = (value, tableMeta, updateValue) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/mytask/approved/print?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(tableMeta.rowData?.[0]),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  render() {
    let dataArray = [];
    this.state.MyTaskList?.map((data) => {
      let mdData = [
        data.referenceno,
        data.employee,
        data.edoctype,
        data.submitteddate
          ? moment(data.submitteddate).format("DD-MM-yyyy HH:mm:ss")
          : "",
        data.status,
        data.description,
      ];
      dataArray.push(mdData);
      return null;
    });
    const columns = [
      {
        name: "referenceno",
        label: "Reference No",
        options: {
          filter: false,
          sort: true,
        },
        editable: true,
      },
      {
        name: "employee",
        label: "Employee Name",
        options: {
          filter: true,
          sort: true,
        },
        editable: true,
      },
      {
        name: "edoctype",
        label: "eDoc Type",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "submitteddate",
        label: "Submitted Date",
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                <div className="badge badge-approved">{value}</div>
              </>
            );
          },
        },
      },
      {
        name: "description",
        label: "Description",
        options: {
          filter: true,
          sort: true,
          // customBodyRender: (value) => {
          //   const maxLength = 30;
          //   if (value.length > maxLength) {
          //     return (
          //       <Tooltip title={value}>
          //         <span>{value.substring(0, maxLength) + "..."}</span>
          //       </Tooltip>
          //     );
          //   }
          //   return value;
          // },
          customBodyRender: (value) => {
            const hasHtml = /<\/?[a-z][\s\S]*>/i.test(value);
            if (hasHtml) {
              return (
                <span
                  dangerouslySetInnerHTML={{
                    __html: value,
                  }}></span>
              );
            } else {
              const maxLength = 30;
              if (value.length > maxLength) {
                return (
                  <Tooltip title={value}>
                    <span>{value.substring(0, maxLength) + "..."}</span>
                  </Tooltip>
                );
              }
              return value;
            }
          },
        },
      },
      // {
      //   name: "description",
      //   label: "Description",
      //   options: {
      //     filter: true,
      //     sort: true,
      //   },
      // },
      {
        name: "action",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                <ReactTooltip />
                <img
                  className="action-right-space mouse-pointer"
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/awesome-eye.svg"
                  }
                  alt="View"
                  onClick={() =>
                    this.viewRequest(value, tableMeta, updateValue)
                  }
                  data-tip="View"
                />
                <img
                  className="action-right-space mouse-pointer"
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/metro-flow-tree.svg"
                  }
                  data-tip="WorkFlow"
                  alt="Metro Flow Tree"
                  onClick={() =>
                    this.workflowRequest(value, tableMeta, updateValue)
                  }
                />
                <img
                  className="action-right-space mouse-pointer"
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/print-standard-pdf.svg"
                  }
                  alt="Standard Print"
                  onClick={() =>
                    this.printRequest(value, tableMeta, updateValue)
                  }
                  data-tip="Standard Print"
                />
              </>
            );
          },
        },
      },
    ];
    const options = {
      filterType: "checkbox",
      download: false,
      print: false,
      textLabels: {
        body: {
          noMatch: this.state.loading ? (
            "Sorry, there is no matching data to display"
          ) : (
            <Spinner
              animation="border"
              variant="primary"
              style={{ margin: "auto" }}
            />
          ),
        },
      },
      onTableChange: (action, tableState) => {
        if (this.state.isdownloadExcelFirstLoadDone === 0) {
          if (action === "propsUpdate") {
            this.setState({
              downloadExcel: tableState.displayData,
              isdownloadExcelFirstLoadDone: 1,
            });
          }
        }
        if (action === "search" || action === "sort") {
          (async () => {
            await this.setState({ downloadExcel: [] });
          })();
          this.setState({ downloadExcel: tableState.displayData });
        }
      },
      customToolbar: () => {
        return (
          <>
            <button
              className="MuiButtonBase-root MuiIconButton-root MUIDataTableToolbar-icon-23"
              tabindex="0"
              type="button"
              data-testid="Download CSV-iconButton"
              aria-label="Download CSV"
              onClick={this.downloadExcelFile}>
              <span className="MuiIconButton-label">
                <svg
                  className="MuiSvgIcon-root"
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true">
                  <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"></path>
                </svg>
              </span>
              <span className="MuiTouchRipple-root"></span>
            </button>
          </>
        );
      },
    };

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item active>My Task : Approved List</Breadcrumb.Item>
        </Breadcrumb>
        <MUIDataTable
          title={"My Task : Approved List"}
          data={dataArray}
          columns={columns}
          options={options}
        />
        <FloatingButton />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(approvedList);
